// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.toolbar-color {
  background: linear-gradient(135deg, #2c3e50, #4a6572) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}
.nav-buttons {
  padding: 0;
  margin-left: 8px !important;
}
.nav-button-prev {
  padding: 0;
  margin: 0;
  transition: transform 0.2s ease;
}
.nav-button-prev:hover {
  transform: scale(1.1);
}
.localeInfo {
  text-align: right;
  margin-right: 0;
  width: 5em !important;
  font-weight: 500;
  letter-spacing: 0.5px;
}
.list .icon {
  width: 20px;
  height: 20px;
  margin-right: 8px;
}
.menu__content {
  border-radius: 8px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}
.call-end {
  width: 36px;
  margin-left: 5px;
}
.end-live-chat-btn {
  width: unset !important;
  border-radius: 20px !important;
  transition: all 0.3s ease;
  padding: 8px 16px !important;
  min-width: auto !important;
  background-color: white !important;
  color: #333 !important;
  border: 2px solid #ddd !important;
}
.hangup-text {
  font-size: 14px;
  font-weight: 500;
  margin-right: 8px;
  color: #333 !important;
  display: inline-block;
}
.end-live-chat-btn:hover {
  background-color: #f5f5f5 !important;
  border-color: #ccc !important;
}
.end-live-chat-btn:disabled {
  background-color: #f9f9f9 !important;
  color: #999 !important;
  border-color: #eee !important;
}
.end-live-chat-btn:disabled .hangup-text {
  color: #999 !important;
}
.toolbar-image {
  margin-left: 0px !important;
  max-height: 100%;
  border-radius: 4px;
}
.toolbar-title {
  width: max-content;
  font-weight: 500 !important;
  letter-spacing: 0.5px;
}
.toolbar-title h2 {
  font-size: 1.2rem;
  font-weight: 500;
}
.min-max-toggle, .help-toggle, .menu {
  transition: transform 0.2s ease;
}
.min-max-toggle:hover, .help-toggle:hover, .menu:hover {
  transform: scale(1.1);
}
.v-list-item-title {
  font-weight: 400;
  letter-spacing: 0.3px;
  font-size: 12px!important;
}
.v-tooltip .tooltip-custom {
  background-color: rgba(44, 62, 80, 0.9) !important;
  border-radius: 6px !important;
  font-weight: 400;
  letter-spacing: 0.3px;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
